import React, { useState, useEffect } from "react";
import service1 from "../assets/about_us_1.webp";
import yourimage from "../assets/about4.webp";
import yourimage1 from "../assets/about5.webp";
import yourimage2 from "../assets/about6.webp";
import yourimage3 from "../assets/about3.webp";
import yourimage4 from "../assets/about2.webp";
import yourimage5 from "../assets/about1.webp";
import AboutUsBannerMobile from "../assets/about_us_banner_mobile.webp";
import AboutUsBanner from "../assets/about_us_banner.webp";
import "../App.css";
import bgCircle from "../assets/about_us_bg.webp";
import OurBlogs from "../pages/OurBlogs";
import useLazyImage, {
  LazyImageComponent,
} from "../components/lazyloader/LazyImage";

export default function AboutUs() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth <= 768;
  const isTablet = windowWidth > 768 && windowWidth <= 1024;

  const bannerImage = isMobile ? AboutUsBannerMobile : AboutUsBanner;
  const { ref, loadedSrc } = useLazyImage(bannerImage);

  const pillars = [
    {
      title: "Innovation",
      text: "Adopting smarter, faster, and simpler ways to make borrowing effortless.",
      img: yourimage,
    },
    {
      title: "Integrity",
      text: "Guided by honesty, fairness, and strong ethics in every transaction.",
      img: yourimage1,
    },
    {
      title: "Trust",
      text: "Earning confidence through transparency, reliability, and secure financial services.",
      img: yourimage2,
    },
    {
      title: "Excellence",
      text: "Delivering consistent quality, speed, and professionalism in all services.",
      img: yourimage3,
    },
    {
      title: "Diversity",
      text: "Welcoming different perspectives, ideas, and cultures while empowering every customer equally.",
      img: yourimage4,
    },
    {
      title: "Agility",
      text: "Quick to respond, adapt, and provide flexible solutions for changing needs.",
      img: yourimage5,
    },
  ];

  return (
    <>
      {/* HERO BANNER */}
      <section className="w-100 position-relative">
        <div className="container-fluid p-0">
          <div
            ref={ref}
            className="position-relative w-100 d-flex hero-banner"
            style={{
              minHeight:
                windowWidth <= 768
                  ? "500px" // Mobile
                  : windowWidth <= 1024
                  ? "400px" // Tablet
                  : windowWidth <= 1600
                  ? "500px" // Medium Desktop
                  : "750px", // Large Desktop
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundImage: loadedSrc ? `url(${loadedSrc})` : "none",
              alignItems: windowWidth <= 768 ? "flex-start" : "center",
              paddingTop: windowWidth <= 768 ? "40px" : "0",
            }}
          >
            {/* Overlay */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: 1,
              }}
            ></div>

            <div className="container-fluid">
              <div className="row align-items-center">
                <div className="col-1"></div>
                <div
                  className="col-10"
                  style={{
                    position: "relative",
                    zIndex: 2,
                    width:
                      windowWidth <= 768
                        ? "90%"
                        : windowWidth <= 1024
                        ? "70%"
                        : "55%",
                    textAlign: windowWidth <= 768 ? "center" : "left",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: windowWidth <= 768 ? "center" : "flex-start",
                  }}
                >
                  <div className="text-gray text-start">
                    <h1
                      className="fw-semibold mb-2"
                      style={{
                        fontSize:
                          windowWidth <= 768
                            ? "24px"
                            : windowWidth <= 1024
                            ? "24px"
                            : "40px",
                        textAlign: "left",
                        lineHeight: "1.2",
                        fontWeight: "700",
                      }}
                    >
                      Delivers Expert Financial
                      <br /> Solutions for Growth.
                    </h1>
                    <p
                      className="mb-4"
                      style={{
                        fontSize:
                          windowWidth <= 768
                            ? "14px"
                            : windowWidth <= 1024
                            ? "16px"
                            : "18px",
                        textAlign: "left",
                        maxWidth: "500px",
                      }}
                    >
                      Unlock funds in minutes with flexible repayment options,
                      minimal paperwork, and 100% secure storage
                    </p>
                  </div>
                </div>
                <div className="col-1"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="our-beginnings"
        style={{
          background:
            "linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, #FFFEF4 58%, rgba(255, 255, 255, 1) 100%)",
          position: "relative",
          overflow: "hidden",
          padding: windowWidth <= 768 ? "40px 0" : "40px 0",
        }}
      >
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-1"></div>
            <div className="col-10">
              <div
                className="row align-items-center"
                style={{
                  maxWidth: "1400px",
                  margin: "0",
                }}
              >
                <div
                  className="col-12 col-lg-6 mb-4 mb-lg-0 order-2 order-lg-1"
                  style={{
                    paddingLeft: "0",
                    paddingRight: windowWidth > 1024 ? "60px" : "15px",
                  }}
                >
                  <LazyImageComponent
                    src={service1}
                    alt="Service 1"
                    className="img-fluid"
                    style={{
                      maxWidth:
                        windowWidth <= 768
                          ? "100%"
                          : windowWidth <= 1024
                          ? "100%"
                          : "100%",
                      height: "auto",
                      display: "block",
                    }}
                  />
                </div>

                <div
                  className="col-12 col-lg-6 order-1 order-lg-2"
                  style={{
                    paddingLeft: windowWidth > 1024 ? "10px" : "5px",
                    paddingRight: "0",
                  }}
                >
                  <div>
                    <h4
                      className="fw-semibold mb-3"
                      style={{
                        fontSize:
                          windowWidth <= 768
                            ? "24px"
                            : windowWidth <= 1024
                            ? "28px"
                            : "32px",
                        textAlign: windowWidth <= 768 ? "center" : "left",
                      }}
                    >
                      Our Beginnings
                    </h4>

                    <p
                      style={{
                        fontSize:
                          windowWidth <= 768
                            ? "14px"
                            : windowWidth <= 1024
                            ? "15px"
                            : "17px",
                        textAlign: windowWidth <= 768 ? "center" : "left",
                        marginBottom: "16px",
                      }}
                    >
                      Every big dream starts with a small step—and ours was a
                      belief: finance should fuel dreams, not fears. Shubh Paisa
                      was built to simplify loans, insurance, and payments so
                      people can focus on their future, not financial hurdles.
                    </p>
                    <p
                      style={{
                        fontSize:
                          windowWidth <= 768
                            ? "14px"
                            : windowWidth <= 1024
                            ? "15px"
                            : "17px",
                        textAlign: windowWidth <= 768 ? "center" : "left",
                        marginBottom: "20px",
                      }}
                    >
                      Pre–Approved loan now available for existing customers.
                      Kindly fill in the details below. Pre–Approved loan now
                      available for existing customers. Kindly fill in the
                      details below.Pre–Approved loan now available for existing
                      customers. Kindly fill in the details below.Pre–Approved
                      loan now available for existing customers. Kindly fill in
                      the details below.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-1"></div>
          </div>
        </div>
      </section>

      <section
        style={{
          backgroundColor: "#FFF0CC",
          backgroundImage: `url(${bgCircle})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "contain",
          width: "100%",
          minHeight: "70vh",
          maxWidth: "100%",
          padding: windowWidth <= 768 ? "40px 0" : "130px ",
        }}
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-1"></div>
            <div className="col-10">
              <div style={{ maxWidth: "1400px", margin: "0" }}>
                <h4
                  className="fw-semibold mb-4"
                  style={{
                    fontSize:
                      windowWidth <= 768
                        ? "24px"
                        : windowWidth <= 1024
                        ? "28px"
                        : "32px",
                    color: "#1e1e1e",
                    textAlign: "center",
                  }}
                >
                  The Pillars of Shubh Paisa
                </h4>

                {/* Cards */}
                <div className="row g-4">
                  {pillars.map((pillar, index) => (
                    <div key={index} className="col-12 col-sm-6 col-lg-4 m-0">
                      <div
                        className="card border-0 shadow-sm rounded-4 p-3 mt-4"
                        style={{
                          backgroundColor: "#fff",
                          display: "flex",
                          alignItems: "center",
                          textAlign: "left",
                          minHeight: windowWidth <= 768 ? "120px" : "160px",
                        }}
                      >
                        <div className="d-flex align-items-center w-100 mt-0 mt-lg-4">
                          <div
                            className="me-3 flex-shrink-0"
                            style={{
                              width: windowWidth <= 768 ? "50px" : "100px",
                              height: windowWidth <= 768 ? "60px" : "70px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              borderRadius: "15px",
                            }}
                          >
                            <LazyImageComponent
                              src={pillar.img}
                              alt={pillar.title}
                              className="img-fluid"
                              style={{
                                maxWidth:
                                  windowWidth <= 768 ? "80px" : "140px",
                              }}
                            />
                          </div>
                          <div>
                            <h5
                              className="fw-semibold mb-1"
                              style={{
                                fontSize:
                                  windowWidth <= 768
                                    ? "16px"
                                    : windowWidth <= 1024
                                    ? "17px"
                                    : "18px",
                                color: "#1e1e1e",
                              }}
                            >
                              {pillar.title}
                            </h5>
                            <p
                              className="mb-0"
                              style={{
                                fontSize:
                                  windowWidth <= 768
                                    ? "13px"
                                    : windowWidth <= 1024
                                    ? "14px"
                                    : "15px",
                                lineHeight: "1.5",
                                color: "#555",
                              }}
                            >
                              {pillar.text}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-1"></div>
          </div>
        </div>
      </section>

    
      <section className="about-us-content py-5">
        <div className="row">
          <div className="col-2 d-none d-lg-block"></div>

          <div className="col-12 col-lg-8">
            <h3
              className="text-center mb-4 mb-md-5 fw-semibold"
              style={{ fontSize: "32px" }}
            >
              About us
            </h3>

            <div className="row g-4 justify-content-center mx-1">
              <div className="col-12 col-md-6">
                <div
                  className="h-100 p-3 p-md-4 p-lg-4 p-xl-4 p-xxl-4 rounded-4 rounded-lg-5"
                  style={{ backgroundColor: "#eeffdf" }}
                >
                  <h4 className="mb-3 fw-semibold">Who are we</h4>
                  <p className="mb-0">
                    At Shubh Paisa, we believe that financial freedom should be
                    a right, not a privilege. We are a dynamic financial
                    solutions provider that empowers individuals, businesses,
                    and families with customized loan options, secure insurance
                    policies, and seamless payment solutions.
                    <br />
                    <br />
                    With a mission to simplify financial complexities, we bring
                    clarity, transparency, and convenience to every financial
                    decision you make.
                    <br />
                    <br />
                    Founded with the vision of making finance accessible to
                    everyone, Shubh Paisa is more than just a service—it's a
                    commitment to your dreams.
                  </p>
                </div>
              </div>

              <div className="col-12 col-md-6">
                <div className="d-flex flex-column h-100 gap-4">
                  <div
                    className="p-3 p-md-4 p-lg-4 p-xl-4 p-xxl-4 rounded-4 rounded-lg-5"
                    style={{ backgroundColor: "#dfe2ff" }}
                  >
                    <h4 className="mb-3 fw-semibold">Our Vision</h4>
                    <p className="mb-0">
                      To be the most trusted and innovative financial partner
                      for individuals and businesses, revolutionizing the way
                      people borrow, insure, and transact through
                      technology-driven solutions and customer-centric
                      services
                    </p>
                  </div>

                  <div
                    className="p-3 p-md-4 p-lg-4 p-xl-4 p-xxl-4 rounded-4 rounded-lg-5"
                    style={{ backgroundColor: "#dfebff" }}
                  >
                    <h4 className="mb-3 fw-semibold">Our Core Value</h4>
                    <p className="mb-0">
                      To be the most trusted and innovative financial partner
                      for individuals and businesses, revolutionizing the way
                      people borrow, insure, and transact through
                      technology-driven solutions and customer-centric
                      services
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-2 d-none d-lg-block"></div>
        </div>
      </section>

      <OurBlogs />
    </>
  );
}
